// extracted by mini-css-extract-plugin
export var arrowIcon = "AccordionContent-module--arrowIcon--29b54";
export var boldText = "AccordionContent-module--boldText--04da4";
export var categories_container = "AccordionContent-module--categories_container--79b59";
export var categories_list = "AccordionContent-module--categories_list--7de24";
export var categories_productChoise = "AccordionContent-module--categories_productChoise--79712";
export var category__container = "AccordionContent-module--category__container--c29b0";
export var category_dropdown_container = "AccordionContent-module--category_dropdown_container--2c9ec";
export var category_title = "AccordionContent-module--category_title--9db9a";
export var center__cotents = "AccordionContent-module--center__cotents--9f3b6";
export var container = "AccordionContent-module--container--b78c0";
export var container__img = "AccordionContent-module--container__img--f6d94";
export var container__section = "AccordionContent-module--container__section--76409";
export var container_destacados = "AccordionContent-module--container_destacados--df118";
export var container_img = "AccordionContent-module--container_img--7dfea";
export var dropdown = "AccordionContent-module--dropdown--dacdb";
export var dropdown__content = "AccordionContent-module--dropdown__content--0fec3";
export var imageSection = "AccordionContent-module--imageSection--e1c8b";
export var names = "AccordionContent-module--names--22299";
export var open = "AccordionContent-module--open--258df";
export var rotate = "AccordionContent-module--rotate--6a82c";
export var rotateOpen = "AccordionContent-module--rotateOpen--771bb";
export var selectedCategory = "AccordionContent-module--selectedCategory--2d4d4";
export var subcategory_container = "AccordionContent-module--subcategory_container--84be5";
export var subcategory_dropdown = "AccordionContent-module--subcategory_dropdown--da8a7";
export var subcategory_title = "AccordionContent-module--subcategory_title--e5f19";
export var texto = "AccordionContent-module--texto--75ad2";
export var title = "AccordionContent-module--title--fe431";